import { useEffect } from "react";
import { STORAGE_REDIRECT_AFTER_AUTH } from "../../constants/common";
import { useUser } from "./useUser";
import { api } from "../../api";
export const useAuth = () => {
    const [, setUser] = useUser();
    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            api.auth.getDevAuth().then(setUser);
        }
        else {
            const redirectUrl = window.localStorage.getItem(STORAGE_REDIRECT_AFTER_AUTH);
            if (redirectUrl && window.location.href !== redirectUrl) {
                window.location.href = redirectUrl;
            }
            else {
                window.localStorage.setItem(STORAGE_REDIRECT_AFTER_AUTH, window.location.href);
                api.auth.getAuthSso().then(response => {
                    window.localStorage.removeItem(STORAGE_REDIRECT_AFTER_AUTH);
                    setUser(response);
                });
            }
        }
    }, []); // eslint-disable-line
};
